import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    icons: {
    defaultSet: 'mdi',
    iconfont: 'mdi', // 追加
    // aliases,
    // sets: {
    //   mdi,
    // }
  },
}

export default new Vuetify(opts)

